import create from "zustand";
import defaultPaymentInfoServiceInstance from "../../../provider/paymentInfoService";
import usePaymentCheckoutState from "./paymentCheckoutState";

interface PaymentCheckoutVoucherState {

    hasVoucherInput: boolean;
    onlyGiftcards: boolean;

    currentInput: string;
    setCurrentInput: (i: string) => void;

    redeemVoucher: () => Promise<void>;
    clearVoucher: () => Promise<void>;

}

export const usePaymentCheckoutVoucherState = create<PaymentCheckoutVoucherState>(
    (set, get) => (
        {

            hasVoucherInput: true,
            onlyGiftcards: false,

            currentInput: "",
            setCurrentInput: (currentVoucherInput) => set( { currentInput: currentVoucherInput }),

            clearVoucher: async () => {
                set( {currentInput: ""} );
                await defaultPaymentInfoServiceInstance.clearVoucherCode();
                await usePaymentCheckoutState.getState().recalculate();
            },

            redeemVoucher: async () => {
                await defaultPaymentInfoServiceInstance.setVoucherCode(get().currentInput);
                await usePaymentCheckoutState.getState().recalculate();
            }

        }
    )
);
